import { useState } from 'react';
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@nextui-org/react';
import { useAppDispatch } from '../../store/hooks';
import { resetPwdThunk } from '../../store/user/userThunks';

export interface ResetModalProps {
  isOpen: boolean;
  onOpenChange: () => void;
}

export default function ResetModal({ isOpen, onOpenChange }: ResetModalProps) {
  const dispatch = useAppDispatch();
  const [usrname, setUsrname] = useState('');
  const [pwd, setPwd] = useState('');

  const resetPassword = async () => {
    dispatch(resetPwdThunk({ username: usrname, password: pwd }));
  };

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      size="sm"
      backdrop="blur"
      scrollBehavior="inside"
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader>Password Reset</ModalHeader>
            <ModalBody className="reset-body-modal">
              <Input
                label="Username"
                value={usrname}
                onChange={(e) => setUsrname(e.target.value)}
              />
              <Input
                label="Password"
                type="password"
                value={pwd}
                onChange={(e) => setPwd(e.target.value)}
              />
            </ModalBody>
            <ModalFooter className="reset-footer-modal">
              <Button
                onPress={async () => {
                  await resetPassword();
                  onClose();
                }}
              >
                Confirm
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
}
